import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import EditBasicInfoView from "./EditBasicInfoView";
import { GearContext } from "./GearDetailPage";

const BasicInfoView = () => {
  const { id, gearData, save } = useContext(GearContext);
  const modal = useModals();

  function editHandler() {
    modal.present({
      title: "Edit Basic Information",
      children: (
        <EditBasicInfoView
          initialValues={{
            nameCn: gearData.nameCn || "",
            size: gearData.size || "",
            weight: gearData.weight || "",
            description: gearData.description || "",
            hsCode: gearData.hsCode || "",
            materials: gearData.materials || "",
          }}
          saveHandler={saveHandler}
        />
      ),
    });
  }

  function saveHandler(newValues) {
    modal.hide();

    const newGearData = { ...gearData, ...newValues };
    save({
      variables: {
        id,
        gearData: JSON.stringify(newGearData, " ", 2),
      },
    });
  }

  return (
    <div className="card">
      <div className="flex justify-between items-center space-x-6">
        <h5>Basic Information</h5>
        <Button onClick={editHandler}>Edit</Button>
      </div>

      <div className="mt-2 -mx-2 whitespace-pre-wrap space-y-3">
        <table>
          <tbody>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Name CN: </label>
              </td>
              <td className="w-full">{gearData.nameCn}</td>
            </tr>

            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Size: </label>
              </td>
              <td className="w-full">{gearData.size}</td>
            </tr>

            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Weight(g): </label>
              </td>
              <td>{gearData.weight}</td>
            </tr>

            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>HS Code: </label>
              </td>
              <td>{gearData.hsCode}</td>
            </tr>

            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Materials: </label>
              </td>
              <td className="mt-1">{gearData.materials}</td>
            </tr>

            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td className="align-baseline">
                <label>Description: </label>
              </td>
              <td className="mt-1 align-baseline">{gearData.description}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BasicInfoView;
